export default {

  get(take = 20, page) {
    return env.API.post('user/ticket/getAll', {take: take, page: page})
  },
  create(subject, message, email, file) {
    return env.API.post('user/ticket/create', {subject:subject, message:message, email : email, file})
  },
  remove(id) {
    // return env.API.get('', id)
  },
  select(id) {
    return env.API.post('user/ticket/select', {id : id})
  },

  viewed(id) {
    return env.API.post('user/ticket/viewed', {id : id})
  },
  isViewed() {
    return env.API.post('user/ticket/isViewed')
  }

}
